import { useQuery } from 'react-query';

import {
  applicantDetailsKey,
  applicantDetailsRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicantDetailsProps = {
  applicantId?: number;
};

export const useGetApplicantDetails = ({
  applicantId,
}: UseGetApplicantDetailsProps) => {
  const { data: applicantDetailsData } = useQuery({
    queryKey: [applicantDetailsKey, applicantId],
    queryFn: () =>
      axiosInstance
        .post(applicantDetailsRoute, { applicant_id: applicantId })
        .then((res) => res.data),
    enabled: Boolean(applicantId),
    refetchOnWindowFocus: false,
  });
  return { applicantDetailsData };
};
